import React from "react";
import Image from "next/image";
import webBanner from "../public/images/page_banner/sangam-specs_desk.jpg";
import mobBanner from "../public/images/page_banner/sangam-specs_mob.jpg";
import { Col, Container, Row } from "react-bootstrap";
import axios from "axios";
import qs from "qs";
import Seo from "@/components/seo/Seo";

const SangamSpecification = ({ data }) => {
  const seo = data?.attributes?.seo;

  return (
    <>
      <Seo seo={seo} />

      <section
        id="carouselExampleDark"
        className="carousel carousel-dark slide"
      >
        <div className="carousel-inner">
          <div className="carousel-item active" data-bs-interval="10000">
            <Image
              src={webBanner}
              className="d-none d-md-block  w-100"
              alt="banner"
              style={{ width: "auto", height: "auto" }}
            />
            <Image
              src={mobBanner}
              className="d-block d-md-none  w-100"
              alt="banner"
              style={{ width: "auto", height: "auto" }}
            />
          </div>
        </div>
      </section>
      <section className="main-section aboutus-section specification-section sec-padd">
        <Container>
          <Row>
            <Col md={6}>
              <div className="specification-wrap">
                <div
                  className="specification-box"
                  data-aos="fade-up"
                  data-aos-delay="100"
                  data-aos-duration="1000"
                >
                  <div className="specification-heading">
                    <span className="space-title heading02">Structure</span>
                    <span className="spec-img">
                      <Image
                        fill
                        className="image"
                        alt="icon"
                        src="/images/specification/structure.png"
                      />
                    </span>
                  </div>
                  <ul className="ul-list">
                    <li>Pile Foundation for durability &amp; stability.</li>
                    <li>Earthquake resistant RCC Superstructure</li>
                  </ul>
                </div>
                <div
                  className="specification-box"
                  data-aos="fade-up"
                  data-aos-delay="300"
                  data-aos-duration="1000"
                >
                  <div className="specification-heading">
                    <span className="space-title heading02">Toilets</span>
                    <span className="spec-img">
                      <Image
                        fill
                        className="image"
                        alt="icon"
                        src="/images/specification/toilets.png"
                      />
                    </span>
                  </div>
                  <ul className="ul-list">
                    <li>CP Fittings of repute make.</li>
                    <li>
                      Wall Ceramic tiles up to door height (Size – 18” X 12”).
                    </li>
                    <li>Sanitary ware – white porcelain.</li>
                    <li>Provision for geyser &amp; exhaust point.</li>
                    <li>Mirror &amp; Towel Ring</li>
                  </ul>
                </div>
                <div
                  className="specification-box"
                  data-aos="fade-up"
                  data-aos-delay="500"
                  data-aos-duration="1000"
                >
                  <div className="specification-heading">
                    <span className="space-title heading02">Lift</span>
                    <span className="spec-img">
                      <Image
                        fill
                        className="image"
                        alt="icon"
                        src="/images/specification/lift.png"
                      />
                    </span>
                  </div>
                  <ul className="ul-list">
                    <li>
                      3 high-speed passenger lifts (including 1 stretcher lift)
                      in each tower
                    </li>
                  </ul>
                </div>
                <div
                  className="specification-box"
                  data-aos="fade-up"
                  data-aos-delay="700"
                  data-aos-duration="1000"
                >
                  <div className="specification-heading">
                    <span className="space-title heading02">Kitchen</span>
                    <span className="spec-img">
                      <Image
                        fill
                        className="image"
                        alt="icon"
                        src="/images/specification/kitchen.png"
                      />
                    </span>
                  </div>
                  <ul className="ul-list">
                    <li>
                      Cuddapah counter with stainless steel sink and taps of
                      repute make.
                    </li>
                    <li>
                      Ceramic tiles dado up to 2 ft. above working platform
                      (Size – 18” X 12”).
                    </li>
                    <li>Provision for water inlet for filter.</li>
                    <li>Exhaust provision</li>
                  </ul>
                </div>
                <div
                  className="specification-box"
                  data-aos="fade-up"
                  data-aos-delay="900"
                  data-aos-duration="1000"
                >
                  <div className="specification-heading">
                    <span className="space-title heading02">Windows</span>
                    <span className="spec-img">
                      <Image
                        fill
                        className="image"
                        alt="icon"
                        src="/images/specification/windows.png"
                      />
                    </span>
                  </div>
                  <ul className="ul-list">
                    <li>Natural Colour Anodized Aluminium windows.</li>
                  </ul>
                </div>
                <div
                  className="specification-box"
                  data-aos="fade-up"
                  data-aos-delay="1100"
                  data-aos-duration="1000"
                >
                  <div className="specification-heading">
                    <span className="space-title heading02">Balcony</span>
                    <span className="spec-img">
                      <Image
                        fill
                        className="image"
                        alt="icon"
                        src="/images/specification/balcony.png"
                      />
                    </span>
                  </div>
                  <ul className="ul-list">
                    <li>MS railings.</li>
                  </ul>
                </div>
                <div
                  className="specification-box"
                  data-aos="fade-up"
                  data-aos-delay="1300"
                  data-aos-duration="1000"
                >
                  <div className="specification-heading">
                    <span className="space-title heading02">Power Back-UP</span>
                    <span className="spec-img">
                      <Image
                        fill
                        className="image"
                        alt="icon"
                        src="/images/specification/power.png"
                      />
                    </span>
                  </div>
                  <ul className="ul-list">
                    <li>
                      24x7 Power Back-Up (1 BHK – 0.50 KVA, 2 BHK – 0.75 KVA, 3
                      BHK – 1 KVA.
                    </li>
                  </ul>
                </div>
              </div>
            </Col>
            <Col md={6}>
              <div className="specification-wrap">
                <div
                  className="specification-box"
                  data-aos="fade-up"
                  data-aos-delay="200"
                  data-aos-duration="1000"
                >
                  <div className="specification-heading">
                    <span className="space-title heading02">Lobby</span>
                    <span className="spec-img">
                      <Image
                        fill
                        className="image"
                        alt="icon"
                        src="/images/specification/lobby.png"
                      />
                    </span>
                  </div>
                  <ul className="ul-list">
                    <li>Well–decorated triple height ground floor lobby.</li>
                    <li>Floor lobbies with Vitrified tiles</li>
                  </ul>
                </div>
                <div
                  className="specification-box"
                  data-aos="fade-up"
                  data-aos-delay="400"
                  data-aos-duration="1000"
                >
                  <div className="specification-heading">
                    <span className="space-title heading02">Wall Finish</span>
                    <span className="spec-img">
                      <Image
                        fill
                        className="image"
                        alt="icon"
                        src="/images/specification/wall_finish.png"
                      />
                    </span>
                  </div>
                  <ul className="ul-list">
                    <li>
                      Interior Walls &amp; Ceiling: RCC Structured/AAC block
                      wall with POP finish.
                    </li>
                    <li>Exterior: Weather-proof cement based paint</li>
                  </ul>
                </div>
                <div
                  className="specification-box"
                  data-aos="fade-up"
                  data-aos-delay="600"
                  data-aos-duration="1000"
                >
                  <div className="specification-heading">
                    <span className="space-title heading02">Flooring</span>
                    <span className="spec-img">
                      <Image
                        fill
                        className="image"
                        alt="icon"
                        src="/images/specification/flooring.png"
                      />
                    </span>
                  </div>
                  <ul className="ul-list">
                    <li>Ceramic tiles in all bedrooms. (Size – 16’’ X 16”)</li>
                    <li>
                      Vitrified tiles in living/dining space. (Size – 24” X 24”)
                    </li>
                    <li>
                      Anti–skid ceramic tiles in kitchen &amp; toilets. (Size –
                      12” X 12”)
                    </li>
                    <li>
                      Ceramic Tiles in Balcony attached to bedroom, if any (Size
                      – 16" X 16”)
                    </li>
                    <li>
                      Vitrified Mat finish tiles in Balcony attached to
                      living/dining space, if any (Size – 24" X 24”
                    </li>
                  </ul>
                </div>
                <div
                  className="specification-box"
                  data-aos="fade-up"
                  data-aos-delay="800"
                  data-aos-duration="1000"
                >
                  <div className="specification-heading">
                    <span className="space-title heading02">Electricals</span>
                    <span className="spec-img">
                      <Image
                        fill
                        className="image"
                        alt="icon"
                        src="/images/specification/electricals.png"
                      />
                    </span>
                  </div>
                  <ul className="ul-list">
                    <li>
                      Copper PVC coated wiring in concealed conduits with repute
                      make switches.
                    </li>
                    <li>
                      AC point, TV point &amp; telephone socket in living/dining
                      &amp; all bedrooms.
                    </li>
                    <li>Sufficient electrical points.</li>
                    <li>
                      Electrical points for geyser, exhaust, washing machine,
                      microwave, refrigerator, water purifier, grinder,
                      computer, mobile charging.
                    </li>
                  </ul>
                </div>
                <div
                  className="specification-box"
                  data-aos="fade-up"
                  data-aos-delay="1000"
                  data-aos-duration="1000"
                >
                  <div className="specification-heading">
                    <span className="space-title heading02">Doors</span>
                    <span className="spec-img">
                      <Image
                        fill
                        className="image"
                        alt="icon"
                        src="/images/specification/doors.png"
                      />
                    </span>
                  </div>
                  <ul className="ul-list">
                    <li>
                      Entrance Door: Good quality flush door with magic eye
                      &amp; handle.
                    </li>
                    <li>
                      Internal Doors: Primer finish flush doors with cylindrical
                      locks.
                    </li>
                  </ul>
                </div>
                <div
                  className="specification-box"
                  data-aos="fade-up"
                  data-aos-delay="1200"
                  data-aos-duration="1000"
                >
                  <div className="specification-heading">
                    <span className="space-title heading02">Staircase</span>
                    <span className="spec-img">
                      <Image
                        fill
                        className="image"
                        alt="icon"
                        src="/images/specification/staircase.png"
                      />
                    </span>
                  </div>
                  <ul className="ul-list">
                    <li>2 spacious R.C.C staircases.</li>
                  </ul>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default SangamSpecification;
export async function getServerSideProps() {
  try {
    const query = {
      populate: ["*", "seo", "seo.metaImage", "seo.schema"],
    };

    /** If we are loading projects from anywhere other than the home page, then we load the configuration information also. */

    const queryString = qs.stringify(query, {
      encodeValuesOnly: true,
    });

    const endpoint = `${process.env.NEXT_PUBLIC_BACKEND_API_URL}/api/sangam-specification?${queryString}`;
    // console.log(`Final url: ${endpoint}`);

    const response = await axios.get(endpoint);
    const data = response.data.data;
    // Pass data to the page via props
    return {
      props: { data },
    };
  } catch (error) {
    console.log("Error", error);
  }
}
